import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import MarketingHeader from 'src/components/layout/MarketingHeader';
import SiteFooter from 'src/components/layout/SiteFooter';
import { listBlogPosts } from 'src/content/blogPosts';
import { buildBlogIndexMeta, formatBlogDate } from 'src/helpers/blogMeta';

function BlogIndexPage() {
  const posts = listBlogPosts();
  const meta = buildBlogIndexMeta();

  useEffect(() => {
    document.title = meta.title;
  }, [meta.title]);

  return (
    <div className="min-h-screen bg-[#faf8fc] font-inter text-[#4b5563]">
      <MarketingHeader active="blog" anchorPrefix="/" />

      <section className="border-b border-[#ede9fe] bg-white px-5 py-16 sm:px-10 sm:py-20 lg:px-20">
        <div className="mx-auto max-w-[1120px]">
          <p className="font-sora text-sm font-bold uppercase text-[#7c3aed]">Blog</p>
          <h1 className="mt-3 max-w-[18ch] font-sora text-4xl font-extrabold leading-[1.15] text-[#0f172a] sm:text-5xl">
            Série Especialidades
          </h1>
          <p className="mt-4 max-w-xl text-base leading-[1.6] sm:text-lg">
            Clínica geral, ortodontia, implantodontia e HOF: o que é cada área, a rotina e os primeiros passos depois da graduação.
          </p>
        </div>
      </section>

      <main className="px-5 py-12 sm:px-10 sm:py-16 lg:px-20">
        <div className="mx-auto grid max-w-[1120px] gap-6 md:grid-cols-2">
          {posts.map((post) => (
            <Link
              key={post.slug}
              to={`/blog/${post.slug}`}
              className="flex flex-col overflow-hidden rounded-[20px] border border-[#ede9fe] bg-white shadow-[0px_24px_24px_rgba(124,58,237,0.03)] hover:border-[#ddd6fe]"
            >
              <img
                src={post.cover}
                alt={post.title}
                width={1200}
                height={630}
                className="aspect-[1200/630] w-full object-cover"
              />
              <div className="flex flex-col gap-2 px-5 py-5">
                <span className="w-fit rounded-full bg-[#f5f3ff] px-2.5 py-1 text-[11px] font-bold uppercase tracking-wide text-[#7c3aed]">
                  {post.seriesLabel}
                </span>
                <h2 className="font-sora text-xl font-bold leading-snug text-[#0f172a]">{post.title}</h2>
                <p className="text-[15px] leading-relaxed">{post.excerpt}</p>
                <time className="text-xs text-[#9ca3af]" dateTime={post.date}>
                  {formatBlogDate(post.date)}
                </time>
              </div>
            </Link>
          ))}
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}

export default BlogIndexPage;
